import { FC } from 'react';
import { ProcDetailsResponse, ProcSearchResponse } from '@/shared/api';
import { DiscoverContent } from './DiscoverContent';
import { MyInstanceContent } from './MyInstanceContent';
import { MyProcContent } from './MyProcContent';

type Props = {
  type: 'myProcs' | 'myInstances' | 'discover';
  proc: ProcDetailsResponse | ProcSearchResponse;
};

export const ProcCard: FC<Props> = ({ type, proc }) => {
  if (!type) {
    return null;
  }

  switch (type) {
    case 'myProcs':
      return <MyProcContent proc={proc} />;
    case 'myInstances':
      return <MyInstanceContent proc={proc} />;
    case 'discover':
      return <DiscoverContent proc={proc} />;

    default:
      throw new Error(`Invalid card type "${type}" [Card.tsx]`);
  }
};
